import { map as rxjsmap } from 'rxjs';



import { Injectable } from '@angular/core';
import { EL } from 'src/app/kuba/kunde-EL/models/el-edit';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';

import { BaseServices } from './../../kuba.services';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ELService {

    featureId: number;
    workingModule: any;

    constructor(private http: HttpClient) {
        this.setWorkingModule();
    }

    getClientContactUser(clientId: number) {
        return this.http.get(environment.BASE_URL + '/clientcontact/clientcontactsuser/' + clientId, ).pipe(rxjsmap(result => result));
    }

    getELList() {
        return this.http.get(environment.BASE_URL + '/kundeEL/getall/' + BaseServices.BusinessId, ).pipe(rxjsmap((result: any) => result));
    }

    getELByUser(Id: number) {
        return this.http.get(environment.BASE_URL + '/kundeEL/getuserEL/' + Id, ).pipe(rxjsmap((result: any) => result));
    }

    create(newEL: EL) {
        return this.http.post(environment.BASE_URL + '/kundeEL/save', newEL, ).pipe(rxjsmap(result => result));
    }

    getELById(id: number) {
        let result: any;
        return this.http.get(environment.BASE_URL + '/kundeEL/' + id, ).pipe(rxjsmap((res: any) => res));
    }

    update(ExistingEL: EL) {
        return this.http.put(environment.BASE_URL + '/kundeEL/update', ExistingEL, ).pipe(rxjsmap(result => result));
    }

    deleteEL(id: number) {
        return this.http.delete(environment.BASE_URL + '/kundeEL/delete/' + id, ).pipe(rxjsmap(result => result));
    }


    getELFeatures(businessId: number) {
        this.setWorkingModule();
        return this.http.get(environment.BASE_URL + '/business/' + businessId, ).pipe(rxjsmap((result: any) => {
                let feature = result.Features;
                let elAdditionalFeature = _.find(JSON.parse(feature), { 'id': this.featureId, 'access': true });
                return elAdditionalFeature;
            }));
    }
    getELByUserId(userId: number) {
        return this.http.get(`${environment.BASE_URL}/kundeEL/getallbyuser/${userId}`, ).pipe(rxjsmap(result => result));

    }
    deleteElAttachment(Id) {
        return this.http
            .delete(environment.BASE_URL + '/kundeEL/deleteELattachment/' + Id, ).pipe(rxjsmap(result => result));
    }

    setWorkingModule() {
        this.workingModule = JSON.parse(
            sessionStorage.getItem('workingModule')
        );
        if (this.workingModule !== null) {
            this.featureId = this.workingModule.id;
        }
    }

    getActiveClientContactUser(clientId: number) {
        return this.http.get(environment.BASE_URL + '/clientcontact/activeclientcontactsuser/' + clientId, ).pipe(rxjsmap(result => result));
    }
}
